import React from "react";
import NomineePersonalDetails from "./personal";
import NomineeMobileDetails from "./mobile";
import NomineeEmailDetails from "./email";
import NomineeBankDetails from "./bank";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { isNomineePersonalDetailsMissing } from "../../../helpers/nominee";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function NomineeDetails({
  classes: { accordianSection, contentScroller },
  banks,
  dateRange,
  errorMessage,
  form,
  handleAccordionChange,
  handleChange,
  handleChangeChipSelect,
  options,
  section,
  selectedBankOption = {},
  setSelectedBankOption,
  validateInputLength,
}) {
  return (
    <>
      <Box
        className={accordianSection}
        onClick={() =>
          handleAccordionChange("nomineePersonal", section.nomineePersonal)
        }
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {isNomineePersonalDetailsMissing(form, errorMessage) && (
            <NewReleasesOutlinedIcon />
          )}
          {!isNomineePersonalDetailsMissing(form, errorMessage) && (
            <CheckCircleOutlineIcon sx={{ color: "green" }} />
          )}
          <Typography variant="subtitle2">Nominee Details</Typography>
        </Stack>
        <Box>
          {!section.nomineePersonal && <ExpandMoreIcon fontSize="medium" />}
          {section.nomineePersonal && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>
      {section.nomineePersonal && (
        <Box
          p={1}
          mt={0}
          sx={{
            height:
              form.nominee_age >= 18
                ? window.screen.height < 740
                  ? "312px"
                  : "382px"
                : window.screen.height < 740
                ? "256px"
                : "312px",
          }}
          className={contentScroller}
        >
          <NomineePersonalDetails
            dateRange={dateRange}
            errorMessage={errorMessage}
            form={form}
            handleChange={handleChange}
            handleChangeChipSelect={handleChangeChipSelect}
            options={options}
            validateInputLength={validateInputLength}
          />

          {form.nominee_dob && form.nominee_age >= 18 && (
            <>
              <NomineeMobileDetails
                errorMessage={errorMessage}
                form={form}
                handleAccordionChange={handleAccordionChange}
                handleChange={handleChange}
                handleChangeChipSelect={handleChangeChipSelect}
                options={options}
                validateInputLength={validateInputLength}
              />

              <NomineeEmailDetails
                errorMessage={errorMessage}
                form={form}
                handleAccordionChange={handleAccordionChange}
                handleChange={handleChange}
                handleChangeChipSelect={handleChangeChipSelect}
                options={options}
              />
            </>
          )}
        </Box>
      )}
      {form.nominee_dob && form.nominee_age >= 18 && (
        <NomineeBankDetails
          banks={banks}
          errorMessage={errorMessage}
          form={form}
          handleAccordionChange={handleAccordionChange}
          handleChange={handleChange}
          handleChangeChipSelect={handleChangeChipSelect}
          options={options}
          section={section}
          selectedBankOption={selectedBankOption}
          setSelectedBankOption={setSelectedBankOption}
          validateInputLength={validateInputLength}
        />
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(NomineeDetails);
